import React,{Suspense} from "react";
import ReactDOM from 'react-dom';
import Resizer from "react-image-file-resizer";
import Dialog from "../component/Dialog";
import DataAdapter from "../adapter/DataAdapter";
import Base64 from 'Base64';

class MessageUtil {
    constructor(){

    }
	onSendSMSHandler = (_receiver, _text) =>{
		if(_receiver){
			let formData = new FormData();

			formData.append('receiver', _receiver);
			formData.append('text', _text);
			const options = {
				method: "POST",
				headers: {
					'Authorization': 'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')
				},
				body: formData
			};

			
			fetch('https://node.renobuilding.ca:3001/sms', options)
				.then(response => response.json())
				.then(response => {
				//this.runQuery("INSERT INTO rb_project_task_details (pt_id,prj_id,sender_id, receiver_id, task) values (" + __PROJECT_TASK_ID__ + "," + __PROJECT_ID__ + "," + cookie.get("v-person-id") + "," + this.state.projects.client_id.split(';')[0] + ",'" + this.state.othernotes + "',)","Task Status updated");
			})
				.catch(err => console.error(err));  
			
		}
	}

	onSendEmail = async (email_from, email_to, email_subject, email_text, email_pass) =>{
			
			let formData = new FormData();
			formData.append("from", 	email_from);
			formData.append("to", 		email_to);
			formData.append("bcc", 		'log@8cogroup.com');
			formData.append("subject", 	email_subject);
			formData.append("text",     email_text);
			formData.append("pass",     email_pass);
			
			let requestOptions = {method: 'POST',headers: {'Authorization':'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')},body : formData};
			let _result = await fetch('https://node.renobuilding.ca:3001/message' , requestOptions)
				.then(response => {
					return Promise.all([response.json(),response])
				})
				.then(([responseData,response]) => {
					if(responseData.status){
						return responseData;
					}						
				})
				.catch(error => {
					console.error('Error:', error);
				});
			return _result;
				
	}
	
}

export default MessageUtil;


